import { fromJS } from 'immutable';

export default fromJS([
  {
    question: 'A concussion is a:',
    answer: 'a',
    answers: {
      a: 'Type of traumatic brain injury or TBI caused by a bump, blow or jolt to the head or by a hit to the body that causes the head and brain to move rapidly back and forth',
      b: 'A brain bruise',
      c: 'Loud sound heard from far away',
    },
  },
  {
    question: 'When can concussions occur?',
    answer: 'c',
    answers: {
      a: 'Only while playing contact sports',
      b: 'Only when the individual who was hit or jolted loses consciousness',
      c: 'In any organized or unorganized recreational sport or activity and most occur without a loss of consciousness',
    },
  },
  {
    question: 'How do you identify a concussion?',
    answer: 'b',
    answers: {
      a: 'By looking at CT or MRI scans of the individual’s brain',
      b: 'By watching for different types of signs and symptoms, such as a change in the athlete’s behavior, thinking, or physical functioning',
      c: 'Asking an athlete if they had their “bell rung” in the last hit',
    },
  },
  {
    question: 'Which of the following are signs of a concussion that you as a coach may identify?',
    answer: 'a',
    answers: {
      a: 'The athlete appears stunned, is unsure of the game, score, or opponent, is confused about their assignment of position, and is answering questions slowly',
      b: 'The athlete follows the rules for safety and the rules of the sport, practices good sportsmanship, and uses the proper equipment for the sport',
      c: 'The athlete looks pale, their tongue is white, and after gently pinching the skin, it does not immediately snap back into place',
    },
  },
  {
    question: 'Which of the following are symptoms of a concussion that an athlete may describe?',
    answer: 'c',
    answers: {
      a: 'The athlete complains of shoulder pain that radiates down the arm to a tingling feeling in the fingers',
      b: 'The athlete feels weak, tired and has stopped sweating',
      c: 'The athlete states the lights hurt their eyes, they feel confused, or complains of a headache',
    },
  },
  {
    question: 'If a player returns to activity before fully healing from the concussion they:',
    answer: 'a',
    answers: {
      a: 'Are more likely to sustain another concussion',
      b: 'Will never have another concussion',
      c: 'Will not sustain another concussion from a similar blow or jolt',
    },
  },
  {
    question: 'What is the first thing you should do as a coach when one of your players has sustained a bump or blow to the head or body and isn’t acting right?',
    answer: 'c',
    answers: {
      a: 'Immediately rush the athlete to the hospital – even if none of the Red Flags are present',
      b: 'Allow the athlete to finish out the quarter/period/half, etc. and then take the athlete for a medical examination',
      c: 'Remove the athlete from play and look for signs or symptoms of a concussion – even those that may appear hours later',
    },
  },
  {
    question: 'Which of the following would indicate a medical emergency and require rushing an athlete to the emergency department immediately?',
    answer: 'b',
    answers: {
      a: 'The athlete seems slightly off balance, complains of a headache, did not lose consciousness, but just “isn’t feeling right.”',
      b: 'The athlete lost consciousness, is persistently vomiting, or seems to become increasingly more confused or restless',
      c: 'The athlete complains of a headache and appears slightly dazed or stunned',
    },
  },
  {
    question: 'The athlete shall be removed from play and the athlete’s parents should be alerted about a possible concussion immediately following the game or practice before allowing the child to go home. What other elements make up the “Heads Up” 4-step action plan?',
    answer: 'c',
    answers: {
      a: 'Ensure that the participant is evaluated by a healthcare professional',
      b: 'Keep the participant out of play the day of the injury and until an appropriate healthcare professional says the player is symptom free and is okay to return to play',
      c: 'Both A & B',
    },
  },
  {
    question: 'When can an athlete return to play after a concussion?',
    answer: 'c',
    answers: {
      a: 'As soon as they are feeling better',
      b: 'After being evaluated by a health care professional',
      c: 'After being cleared by a health care professional and after following a stepwise process in which the athlete’s activity level is slowly increased over a period of days, weeks, or months depending on the athlete’s response to increasingly challenging activities',
    },
  },
  {
    question: 'How can you help prevent concussions?',
    answer: 'c',
    answers: {
      a: 'By ensuring that all athletes wear properly fitted protective equipment, practice good sportsmanship at all times and follow the rules of play',
      b: 'By working with parents, athletes, and school and club administrators to spread awareness about concussion all year: pre-season, during the season and post-season',
      c: 'Both A & B',
    },
  },
  {
    question: 'Why is a return-to-learn plan critical for youth athletes who have sustained a concussion?',
    answer: 'a',
    answers: {
      a: 'Cognitive activities that require concentration, memory, and attention to detail, such as school work and reading, may worsen symptoms and delay recovery if not introduced in an appropriate, individualized process',
      b: 'Student athletes must maintain a 3.5 GPA before being allowed to return to school-sanctioned sports after injury',
      c: 'A return-to-learn plan is not necessary as long as the athlete has completed the return-to-play process and has resumed full competition',
    },
  },
  {
    question: 'At the beginning of each sanctioned sport season, the youth athlete and the athlete’s parent or guardian shall receive information describing the risks, signs and symptoms of concussion. What other tenets comprise Idaho concussion legislation?',
    answer: 'c',
    answers: {
      a: 'A coach or athletic trainer may return an athlete to play the same day they are suspected of sustaining a concussion after obtaining written consent from the athlete’s parent or guardian',
      b: 'If an athlete is 18 years of age, they are no longer considered a youth athlete and are exempt from the concussion and head injury requirements under Idaho’s concussion law',
      c: 'Any athlete playing a school sanctioned sport, who is reasonably suspected of sustaining a concussion, must be immediately removed from play AND in order to return to play, the athlete must obtain medical clearance by a qualified healthcare professional trained in the management of concussion',
    },
  },
  {
    question: 'Why are concussions managed more conservatively in youth than in adults?',
    answer: 'b',
    answers: {
      a: 'Adults brains are not susceptible to concussion',
      b: 'While the brain is still recovering from a concussion, it is particularly vulnerable to further injury; a second concussion during this time in a developing brain can result in catastrophic injury',
      c: 'Concussions often cause permanent learning disabilities in youth athletes',
    },
  },
  {
    question: 'What Idaho resources are available for creating a concussion management protocol for your school or sports league?',
    answer: 'd',
    answers: {
      a: 'Idaho High School Activities Association: idhsaa.org',
      b: 'St. Luke’s Sports Medicine Concussion Clinic: www.stlukesonline/concussion.org',
      c: 'Know Concussion.org: www.knowconcussion.org',
      d: 'All of the above',
    },
  },
]);



// WEBPACK FOOTER //
// ./src/config/questions.js